import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TeamMembersFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: organizationMembers } = useCurrentOrganizationMembers();
    const { teamMemberIds } = filters;

    const labels = useMemo(
        () =>
            organizationMembers
                ?.filter((member) => teamMemberIds?.includes(member.user.id))
                .map((member) => member.user.name) ?? [],
        [organizationMembers, teamMemberIds],
    );

    if (!teamMemberIds || teamMemberIds.length === 0) {
        return null;
    }

    return formatFilterLabel(labels);
};
